import React, { useState, useEffect } from "react";
import { object, string, func } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Headline from "../../atoms/Headline";
import SelectDropdown from "../../atoms/SelectDropdown";
import Icon from "../../icons";
import { staticTexts } from "../../utils/Translate";
import { generateDIstrictNewsSlug } from "../../utils/utils";
import { getDistrictTopics } from "../../helper/api";

import "./tagStorySearch.m.css";

function GenerateMetaData(name, id, parentId = null, slug = "") {
  this.name = name;
  this["external-id"] = id;
  this["parent-external-id"] = parentId;
  this.slug = slug;
}

const TagStorySearch = ({
  className = "",
  publisherAttributes,
  localNewsDivisionSlug,
  localNewsDistrictSlug,
  localNewsSubDistrictSlug,
  navigateToPage,
  pageType,
  toggleFilterSearch,
}) => {
  const [topicsFilter, setTopicsFilter] = useState([]);
  const topicsFilterParent = topicsFilter.filter((topic) => {
    return !topic["parent-external-id"];
  });
  const filterChild = (id) => topicsFilter.filter((item) => item["parent-external-id"] === id);
  const filterParent = (slug) => topicsFilterParent.find((item) => item.slug === slug);
  const filterChildBasedOnSlug = (slug) => topicsFilter.find((item) => item.slug === slug);

  const findItem = (id) => topicsFilter.find((item) => item["external-id"] === id);
  const defaultList = [
    new GenerateMetaData(staticTexts(publisherAttributes.lang).section, 0),
    new GenerateMetaData(staticTexts(publisherAttributes.lang).district, 0),
    new GenerateMetaData(staticTexts(publisherAttributes.lang).upazila, 0),
  ];

  const [selectParent, setSelectParent] = useState(null);
  const [selectChild, setSelectChild] = useState(null);
  const [selectSubChild, setSelectSubChild] = useState(null);
  const [childList, setChildList] = useState([]);
  const [subChildList, setSubChildList] = useState([]);
  const [divisionSlug, setDivisionSlug] = useState(null);
  const [districtSlug, setDistrictSlug] = useState(null);
  const [subDistrictSlug, setSubDistrictSlug] = useState(null);

  const onChangeFunc1 = (e) => {
    setSelectParent(e.target.value);
    setSelectChild(null);
    setSelectSubChild(null);
    setChildList(filterChild(e.target.value));
    const item = findItem(e.target.value);
    setDivisionSlug(item.slug);
    setDistrictSlug(0);
    setSubDistrictSlug(0);
  };

  const onChangeFunc2 = (e) => {
    setSelectChild(e.target.value);
    setSelectSubChild(null);
    setSubChildList(filterChild(e.target.value));
    const item = findItem(e.target.value);
    setDistrictSlug(item.slug);
    setSubDistrictSlug(0);
  };

  const onChangeFunc3 = (e) => {
    setSelectSubChild(e.target.value);
    const item = findItem(e.target.value);
    setSubDistrictSlug(item.slug);
  };

  useEffect(() => {
    getDistrictTopics().then((resp) => setTopicsFilter(resp));
  }, []);

  useEffect(() => {
    if (topicsFilter.length > 0) {
      const setParent = () => {
        const currentParent = filterParent(localNewsDivisionSlug);
        currentParent && setSelectParent(currentParent["external-id"]);
        currentParent && setChildList(filterChild(currentParent["external-id"]));
        const item = currentParent && findItem(currentParent["external-id"]);
        item && setDivisionSlug(item.slug);
      };

      const setChild = () => {
        const currentChild = filterChildBasedOnSlug(localNewsDistrictSlug);
        currentChild && setSelectChild(currentChild["external-id"]);
        currentChild && setSubChildList(filterChild(currentChild["external-id"]));
        const item = currentChild && findItem(currentChild["external-id"]);
        item && setDistrictSlug(item.slug);
      };

      const setSubChild = () => {
        const currentSubChild = filterChildBasedOnSlug(localNewsSubDistrictSlug);
        currentSubChild && setSelectSubChild(currentSubChild["external-id"]);
        const item = currentSubChild && findItem(currentSubChild["external-id"]);
        item && setSubDistrictSlug(item.slug);
      };

      if (localNewsSubDistrictSlug && localNewsDistrictSlug && localNewsDivisionSlug) {
        setParent();
        setChild();
        setSubChild();
      } else if (localNewsDistrictSlug && localNewsDivisionSlug) {
        setParent();
        setChild();
        const currentChild = filterChildBasedOnSlug(localNewsDistrictSlug);
        setSelectChild(currentChild["external-id"]);
        setSubChildList(filterChild(currentChild["external-id"]));
      } else if (localNewsDivisionSlug) {
        setParent();
      }
    }
  }, [topicsFilter]);

  const onClickHandler = () => {
    navigateToPage(`/bangladesh/district-news${generateDIstrictNewsSlug(districtSlug, divisionSlug, subDistrictSlug)}`);
    toggleFilterSearch();
  };

  return (
    <div styleName="base" className={className}>
      {pageType === "home-page" && (
        <Headline text={staticTexts(publisherAttributes.lang).localNews} headlineType={12} className="headline-title" />
      )}
      <SelectDropdown
        list={topicsFilterParent}
        onChange={onChangeFunc1}
        className="dropdown-list"
        defaultItem={defaultList[0]}
        selected={selectParent}
        selectClassName={selectParent ? "active-dropdown" : ""}
      />
      <SelectDropdown
        list={childList}
        onChange={onChangeFunc2}
        className="dropdown-list"
        defaultItem={defaultList[1]}
        selected={selectChild}
        selectClassName={selectChild ? "active-dropdown" : ""}
      />
      <SelectDropdown
        list={subChildList}
        onChange={onChangeFunc3}
        className="dropdown-list"
        defaultItem={defaultList[2]}
        selected={selectSubChild}
        selectClassName={selectSubChild ? "active-dropdown" : ""}
      />
      <button
        styleName="tag-search-btn"
        onClick={onClickHandler}
        data-tracking-category="Button"
        data-tracking-action="Click"
        data-tracking-label="আঞ্চলিক খবর সার্চ বাটন"
      >
        <span styleName="search-icon">
          <Icon
            type="search"
            className="search-icon"
            datatrackingcategory="Button"
            datatrackingaction="Click"
            datatrackinglabel="আঞ্চলিক খবর সার্চ বাটন"
          />
        </span>
        {staticTexts(publisherAttributes.lang).search}
      </button>
    </div>
  );
};

TagStorySearch.propTypes = {
  className: string,
  story: object,
  publisherAttributes: object,
  localNewsDivisionSlug: string,
  localNewsDistrictSlug: string,
  localNewsSubDistrictSlug: string,
  navigateToPage: func,
  pageType: string,
  toggleFilterSearch: func,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  pageType: get(state, ["qt", "pageType"], ""),
});

const mapDispatchToProps = (dispatch) => ({
  navigateToPage: (url) => global.app.navigateToPage(dispatch, url),
});

export default connect(mapStateToProps, mapDispatchToProps)(TagStorySearch);
